<mat-form-field [appearance]="appearance" fxFlex *ngIf="!selectedRequester">
  <mat-label *ngIf="floatLabel">{{ 'MAINTENANCES.REQUESTER' | translate }}</mat-label>
  <input
    type="text"
    matInput
    [matAutocomplete]="auto"
    [(formControl)]="inputValue"
    [required]="required"
    [disabled]="disabled"
    placeholder="{{ 'MAINTENANCES.REQUESTER_PLACEHOLDER' | translate }}"
    fxFlex="90"
  />
  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="setSelectedRequester()">
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
    <mat-option *ngFor="let requester of requesters" [value]="requester.id">
      {{ requester.name }}
    </mat-option>
    <mat-option *ngIf="!requesters.length">
      {{ 'MAINTENANCES.REQUESTER_NOT_FOUND' | translate }}
    </mat-option>
  </mat-autocomplete>
  <mat-error class="pb-4">
    <span *ngIf="inputValue.hasError('required')">{{ 'MAINTENANCES.ERRORS.REQUESTER_REQUIRED' | translate }}</span>
  </mat-error>
</mat-form-field>

<mat-form-field [appearance]="appearance" *ngIf="selectedRequester">
  <mat-label *ngIf="floatLabel">{{ 'MAINTENANCES.REQUESTER' | translate }}</mat-label>
  <div class="flex">
    <input
      type="text"
      [ngClass]="{ 'archived-selected': selectedRequester.archived }"
      matInput
      [value]="selectedRequester.name"
      disabled
      required
    />
    <div class="archived-label" *ngIf="selectedRequester.archived">
      <span>{{ 'MAINTENANCES.ARCHIVED' | translate }}</span>
    </div>
    <button
      mat-icon-button
      [disabled]="disabled"
      *ngIf="selectedRequester"
      class="my-cancel-button accent-700-fg"
      (click)="deselectRequester()"
    >
      <mat-icon class="font-size-20">cancel</mat-icon>
    </button>
  </div>
</mat-form-field>
